import {css} from "lit";

export const radioOnDarkStyles = css`
    --_radio-border-color: var(--sbkRadiobuttonBorderOnDarkEnabled);
    --_radio-border-color-hover: var(--sbkRadiobuttonBorderOnDarkHover);
    --_radio-border-color-active: var(--sbkRadiobuttonBorderOnDarkActive);
    --_radio-border-color-disabled: var(--sbkRadiobuttonBorderOnDarkDisabled);
    --_radio-border-color-focus: var(--sbkRadiobuttonBorderOnDarkFocus);
    --_radio-border-color-error: var(--sbkRadiobuttonBorderOnDarkError);

    --_radio-fg-color: var(--sbkRadiobuttonFgColorOnDarkDefault);
    --_radio-fg-color-hover: var(--sbkRadiobuttonFgColorOnDarkHover);
    --_radio-fg-color-active: var(--sbkRadiobuttonFgColorOnDarkActive);
    --_radio-fg-color-disabled: var(--sbkRadiobuttonFgColorOnDarkDisabled);
    --_radio-fg-color-error: var(--sbkRadiobuttonFgColorOnDarkError);

    --_radio-bg-color: var(--sbkRadiobuttonBgColorOnDarkEnabled);
    --_radio-bg-color-hover: var(--sbkRadiobuttonBgColorOnDarkHover);
    --_radio-bg-color-active: var(--sbkRadiobuttonBgColorOnDarkActive);
    --_radio-bg-color-disabled: var(--sbkRadiobuttonBgColorOnDarkDisabled);
    --_radio-bg-color-focus: var(--sbkRadiobuttonBgColorOnDarkFocus);
    --_radio-bg-color-error: var(--sbkRadiobuttonBgColorOnDarkError);
`;
